module.exports = __webpack_public_path__ + "static/media/avasta.fbe75a44.svg";